import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { Button } from '../button';
import { Illustration } from '../illustration';
import { Typography } from '../typography';
export const ErrorState = (props) => {
    return (_jsxs(FlexBox, { margin: "0 auto", width: "100%", padding: [0, 3], vAlign: "center", hAlign: "center", gap: 2, stack: true, children: [_jsx(Illustration, { type: "error-state" }), props.errorMessage && (_jsx(Typography, { textAlign: "center", variant: "headingMedium", children: props.errorMessage })), props.children && (_jsx(Typography, { color: "text.disabled", textAlign: "center", children: props.children })), props.actionButton && (_jsx(Button, { variant: "outlined", onClick: () => {
                    if (props.actionButton?.link) {
                        window.open(props.actionButton.link, '_blank');
                        return;
                    }
                    window.location.reload();
                }, children: props.actionButton.text }))] }));
};
